<template>
  <ls-table-layout>
    <template #search>
      <SearchForm ref="searchFormRef" @search="onSearch" @toggleAdvanced="onToggleAdvanced" />
    </template>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button
        v-hasPermi="['mes:mesDiscreteJobsCcMo:revokeDispatch']"
        @click="handleCancelDispatch"
        :loading="btnLoading"
        type="danger"
      >撤销派工</a-button>
      <a-button
        v-hasPermi="['mes:mesDiscreteJobsCcMo:getMaterialPrintList']"
        @click="onPrintMoTicket"
        :loading="btnLoading"
        type="primary"
      >打印MO票</a-button>
      <a-button
        v-hasPermi="['mes:mesRequisitionCcDetail:list']"
        @click="onAskPack"
        :loading="btnLoading"
        type="primary"
      >生产领料</a-button>
      <a-button
        v-hasPermi="['mes:mesRequisitionCc:listPickIngLog']"
        @click="onShowPackLog"
        :loading="btnLoading"
      >领料记录</a-button>
      <a-button
        @click="handleClose"
        :loading="btnLoading"
        type="danger"
        v-hasPermi="['mes:mesDiscreteJobsCcMo:batchClose']"
      >关闭</a-button>
      <span v-if="activeTableType === TICKET_TABLE_TYPE.ticketInfo.value">
        <a-button key="export1" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesDiscreteJobsCcMo:export']">导出</a-button>
      </span>
      <span v-else-if="activeTableType === TICKET_TABLE_TYPE.materialInfo.value">
        <a-button key="export2" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesRequirementOperationsCcMo:export']">导出</a-button>
      </span>
      <span v-else-if="activeTableType === TICKET_TABLE_TYPE.relateBill.value">
        <a-button key="export3" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesDiscreteJobsCcMo:associateExport']">导出</a-button>
      </span>
      <span v-else-if="activeTableType === TICKET_TABLE_TYPE.process.value">
        <a-button key="export3" :loading="exportLoading" @click="handleExport" v-hasPermi="['mes:mesOperationsCc:export']">导出</a-button>
      </span>
      <a-button
        v-hasPermi="['mes:mesDiscreteJobsCcMo:getMaterialPrintListMerge']"
        @click="onPrintMoTicket('merge')"
        :loading="btnLoading"
        type="primary"
      >合并打印领料单</a-button>
      <a-button @click="handleMerge" :loading="btnLoading" v-hasPermi="['mes:mesDiscreteJobsCcMo:mergeMaterialRequisition']" type="primary">合单领料申请</a-button>
      <a-button @click="callAI" v-hasPermi="['fun_1933068876942938113_sJpqG']">AI查领料</a-button>
    </div>
    <template v-slot:table>
      <a-tabs v-model="activeTableType" type="card" @change="onTableTypeChange">
        <a-tab-pane v-for="item in tableTypeList" :key="item.value" :tab="item.label"></a-tab-pane>
      </a-tabs>
      <div class="page-header-content">
        <ls-api-table
          ref="baseTable"
          :columns="dyCols"
          :table-props="tableProps"
          :scroll="{ fixScreen: true, x: scrollX }"
          :custom-selection="{ stickyFixed: true }"
          :selectedRows.sync="selectedRows"
          :selection="selection"
          :pagination="pagination"
          :multi-select="isMultiSelect"
          @selectedRowChange="selectedRowChange"
        >
          <template #scheduledStartDateTitle>
            <span>计划开始时间</span>
            <!--<span v-hasPermi="['mes:mesDiscreteJobsCc:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('scheduledStartDate')" type="edit" title="编辑"/>
            </span>-->
          </template>
          <template #scheduledCompletionDateTitle>
            <span>计划完成时间</span>
            <!--<span v-hasPermi="['mes:mesDiscreteJobsCc:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('scheduledCompletionDate')" type="edit" title="编辑"/>
            </span>-->
          </template>
          <template #workCenterNameTitle>
            <span>工作中心</span>
            <span v-hasPermi="['mes:mesDiscreteJobsCcMo:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('workCenterCode')" type="edit" title="编辑"/>
            </span>
          </template>
          <template #teamGroupNameTitle>
            <span>班组</span>
            <span v-hasPermi="['mes:mesDiscreteJobsCcMo:batchEdit']">
              <a-icon v-if="TICKET_TABLE_TYPE.ticketInfo.value === activeTableType" class="action-icon" @click.stop="onBatchEdit('teamGroupCode')" type="edit" title="编辑"/>
            </span>
          </template>
          <template #skipFlag="{ text }">
            {{ skipFlagNameMap[text] }}
          </template>
          <template #scheduledStartDate="{ record }">
            <a-date-picker
              v-if="record.editIs"
              v-model="record.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
              style="min-width: 100%"
            />
            <template v-else>{{ formatDate(record.scheduledStartDate) }}</template>
          </template>
          <template #scheduledCompletionDate="{ record }">
            <a-date-picker
              v-if="record.editIs"
              v-model="record.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }"
              allowClear
              style="min-width: 100%"
            />
            <template v-else>{{ formatDate(record.scheduledCompletionDate) }}</template>
          </template>
          <template #formatDate="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template #YES_OR_NOT="{ text }">
            {{ YES_OR_NOT[text] }}
          </template>
          <template #componentItemCodeList="{ text }">
            <a-tooltip :title="text"><div class="text-3-ellipsis">{{ text && text.toString() }}</div></a-tooltip>
          </template>
          <template #textEllipsis="{ text }">
            <a-tooltip :title="text"><div class="text-3-ellipsis">{{ text }}</div></a-tooltip>
          </template>
          <template #operation="{ record }">
            <div v-hasPermi="['mes:mesDiscreteJobsCcMo:edit']">
              <a-button
                v-if="!record.editIs"
                type="link"
                class="link-btn"
                @click="() => onEdit(record, 1)"
              >编辑</a-button>
              <template v-else>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onSave(record)"
                >保存</a-button>
                <a-button
                  type="link"
                  class="link-btn"
                  :loading="record.loading"
                  @click="() => onEdit(record, 0)"
                >取消</a-button>
              </template>
              <a-button type="link" class="link-btn" @click="handleLog(record)">日志</a-button>
            </div>
          </template>
        </ls-api-table>
      </div>
      <DownloadModal :apiFun="exportApi" ref="download" />
      <OperationLogModel ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      <BatchEditModal ref="BatchEditModalRef" @click="refreshList" />
      <UpdateMaterialModal ref="updateMaterialModalRef" @handle-success="refreshList" />
      <PickMaterialModal ref="pickMaterialModalRef" />
      <PickLogModal ref="pickLogModalRef" />
      <PickingModal ref="pickingModalRef" @successCall="refreshList" :mainBtnLoading="btnLoading" />
      <PrintMergeMaterialModal ref="printMergeMaterialModalRef" />
      <MergePickModal ref="mergePickModalRef" @close="closeMergePickModal" @successCall="refreshList" v-if="showModal.mergePickModal" />
    </template>
  </ls-table-layout>
</template>

<script>
import PickLogModal from '@/views/mes/workOrderManage/moTickets/components/pick-log-modal.vue';
import PickingModal from '@/views/mes/workOrderManage/moTickets/components/picking-modal.vue';
import { generateLsTableResData } from '@/utils/util.js'
import MergePickModal from './components/merge-pick-modal.vue'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import SearchForm from './components/search-form.vue'
import BatchEditModal from './components/batch-edit-modal.vue'
import {
  formatDate,
  TICKET_INFO_COL,
  TICKET_MATERIAL_COL,
  TICKET_TABLE_TYPE,
  TICKET_PROCESS,
  STATUS_CODE,
  YES_OR_NOT
} from './common'
import deepClone from 'lodash/cloneDeep'
import {
  getMesDiscreteJobsCcLogApi
} from '@/api/mes/workOrderManage/ticketsManageCc'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import AddMaterialModal from '@/views/mes/workOrderManage/ticketsManageCc/components/add-material-modal.vue'
import UpdateMaterialModal from '@/views/mes/workOrderManage/ticketsManageCc/components/update-material-modal.vue'
import PrintPickMaterialModal from '@/views/mes/workOrderManage/moTickets/components/print-pick-material-modal.vue'
import PrintMergeMaterialModal from '@/views/mes/workOrderManage/moTickets/components/print-merge-material-modal.vue'
import {
  apiBatchCloseMesDiscreteJobsCcMo,
  apiExportJobsCcAssociateListMo,
  apiExportMesDiscreteJobsCcMo,
  apiGetJobsCcAssociateListMo,
  apiGetMesDiscreteJobsCcMo,
  apiGetMesOperationsCc,
  apiRevokeDispatchMesDiscreteJobsCcMo,
  updateMesDiscreteJobsMo,
  apiExportRequirementOperationsMo,
  apiRequirementOperationsMoList,
  apiExportOperationsCcMo
} from '@/api/mes/workOrderManage/moTickets'
import { IS_JUMP_STATION } from '@/views/mes/basedata/standardProcessNew/enums'

export default {
  name: 'MoTickets',
  components: {
    BatchEditModal,
    OperationLogModel,
    DownloadModal,
    SearchForm,
    MergePickModal,
    AddMaterialModal,
    UpdateMaterialModal,
    PickMaterialModal: PrintPickMaterialModal,
    PickingModal,
    PrintMergeMaterialModal,
    PickLogModal
  },
  data() {
    return {
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      activeTableType: TICKET_TABLE_TYPE.ticketInfo.value,
      btnLoading: false,
      exportLoading: false,
      selection: true,
      logLoading: false,
      logList: [],
      dyCols: [],
      pagination: {
        pageSizeOptions: [ '20', '50', '100', '500' ]
      },
      // 控制弹窗显隐
      showModal: {
        mergePickModal: false // 合并领料弹窗
      },
      operationTypeList: [],
      TICKET_MATERIAL_COL: JSON.parse(JSON.stringify(TICKET_MATERIAL_COL)),
      TICKET_PROCESS: JSON.parse(JSON.stringify(TICKET_PROCESS)),
      TICKET_INFO_COL: JSON.parse(JSON.stringify(TICKET_INFO_COL))
    }
  },
  computed: {
    skipFlagNameMap() {
      return Object.values(IS_JUMP_STATION).reduce((acc, cur) => {
        acc[cur.value] = cur.label;
        return acc;
      }, {})
    },
    scrollX() {
      return this.dyCols.reduce((acc, cur) => {
        return acc + (cur.width || 120)
      }, 200)
    },
    YES_OR_NOT() {
      return YES_OR_NOT
    },
    STATUS_CODE() {
      return STATUS_CODE;
    },
    tableProps() {
      const requestApi = {
        [TICKET_TABLE_TYPE.ticketInfo.value]: generateLsTableResData(apiGetMesDiscreteJobsCcMo),
        [TICKET_TABLE_TYPE.materialInfo.value]: generateLsTableResData(apiRequirementOperationsMoList),
        [TICKET_TABLE_TYPE.relateBill.value]: generateLsTableResData(apiGetJobsCcAssociateListMo),
        [TICKET_TABLE_TYPE.process.value]: generateLsTableResData(apiGetMesOperationsCc)
      }[this.activeTableType]
      return {
        requestApi,
        pageCurrent: false
      }
    },
    tableTypeList() {
      return Object.values(TICKET_TABLE_TYPE);
    },
    isMultiSelect() {
      return ![TICKET_TABLE_TYPE.materialInfo.value].includes(this.activeTableType)
    },
    TICKET_TABLE_TYPE() {
      return TICKET_TABLE_TYPE;
    },
    canEditIs() {
      return (record) => {
        return [STATUS_CODE.DISPATCHED.lookupCode].includes(record.moStatus)
      }
    },
    exportApi() {
      return {
        [TICKET_TABLE_TYPE.ticketInfo.value]: apiExportMesDiscreteJobsCcMo,
        [TICKET_TABLE_TYPE.materialInfo.value]: apiExportRequirementOperationsMo,
        [TICKET_TABLE_TYPE.relateBill.value]: apiExportJobsCcAssociateListMo,
        [TICKET_TABLE_TYPE.process.value]: apiExportOperationsCcMo
      }[this.activeTableType]
    }
  },
  created() {
    this.dyCols = this.TICKET_INFO_COL;
    this.showModal.mergePickModal = false;
  },
  mounted() {
    this.$refs.searchFormRef.getCategoryIdList();
  },
  methods: {
    formatDate,
    // 打印领料单
    onPrintMoTicket(type) {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      if(type === 'merge') {
        this.$refs.printMergeMaterialModalRef.show(this.selectedRows)
      } else {
        this.$refs.pickMaterialModalRef.show(this.selectedRows)
      }
    },
    onShowPackLog() {
      if(this.selectedRows?.length !== 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      const moTicketCode = this.selectedRows[0].moTicketCode;
      this.$refs.pickLogModalRef.show(moTicketCode);
    },
    onAskPack() {
      if(!this.selectedRows?.length) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      let fistItem;
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.DISPATCHED.lookupCode, STATUS_CODE.START_WORK.lookupCode, STATUS_CODE.COMPLETED.lookupCode, STATUS_CODE.RECEIVED.lookupCode].includes(item.moStatus)) {
          return this.$message.warning("只有已派工, 已开工，已完成，已入库状态才能操作")
        }
        if(!fistItem) {
          fistItem = {
            workCenterCode: item.workCenterCode,
            businessType: item.businessType
          }
        } else {
          if(fistItem.workCenterCode !== item.workCenterCode) {
            return this.$message.warning("请选择同一工作中心类型的工单")
          }
          if(fistItem.businessType !== item.businessType) {
            return this.$message.warning("请选择同一业务类型的工单")
          }
        }
      }
      const moTicketCodeList = this.selectedRows.map(item => item.moTicketCode);
      this.$refs.pickingModalRef.show({ moTicketCodeList }, true);
    },
    // 撤销派工
    handleCancelDispatch() {
      if(this.selectedRows?.length !== 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      for(const item of this.selectedRows) {
        if(![STATUS_CODE.DISPATCHED.lookupCode].includes(item.moStatus)) {
          return this.$message.warning("‘已派工状态的工单才能撤销派工，请重新选择工单")
        }
      }
      const idList = this.selectedRows.map(item => item.id);
      this.btnLoading = true;
      apiRevokeDispatchMesDiscreteJobsCcMo(idList).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    onBatchEdit(field) {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      // 新增，已排产的状态都能操作
      let flag = '';
      for(const item of this.selectedRows) {
        // if(![STATUS_CODE.DISPATCHED.lookupCode].includes(item.moStatus)) {
        //   return this.$message.warning("只有已派工状态才能操作")
        // }
        if(field === 'workCenterCode') { // 工作中心，要校验车间是否一致
          if(!flag) {
            flag = item.workCode;
          }else {
            if(flag !== item.workCode) {
              return this.$message.warning("要选择同一车间的单据")
            }
          }
        }
        if(field === 'teamGroupCode') { // 班组，要校验车间+工作中心是否一致
          if(!flag) {
            flag = item.workCode + item.workCenterCode;
          }else {
            if(flag !== item.workCode + item.workCenterCode) {
              return this.$message.warning("要选择车间以及工作中心相同的单据")
            }
          }
        }
      }
      this.$refs.BatchEditModalRef.show(this.selectedRows, field)
    },
    // 关闭
    handleClose() {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.btnLoading = true;
      const idList = this.selectedRows.map(item => item.id);
      apiBatchCloseMesDiscreteJobsCcMo(idList).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功!')
          this.refreshList()
        } else {
          this.$message.error(response.msg)
        }
        this.btnLoading = false
      }).catch(() => {
        this.btnLoading = false
      })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 工单用料表编辑
    onMaterialEdit(field) {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$refs.updateMaterialModalRef.show(this.selectedRows[0], field)
    },
    // $lookupMeaning(operationTypeList, record.operationType)
    onTableTypeChange(value) {
      this.selectedRows = [];
      this.selection = [TICKET_TABLE_TYPE.ticketInfo.value, TICKET_TABLE_TYPE.materialInfo.value].includes(this.activeTableType);
      if(this.activeTableType === TICKET_TABLE_TYPE.materialInfo.value) {
        this.dyCols = this.TICKET_MATERIAL_COL;
      }else if(this.activeTableType === TICKET_TABLE_TYPE.process.value) {
        this.dyCols = this.TICKET_PROCESS
      }else if (this.activeTableType === TICKET_TABLE_TYPE.ticketInfo.value) {
        this.dyCols = this.TICKET_INFO_COL;
      }else if(this.activeTableType === TICKET_TABLE_TYPE.relateBill.value) {
        this.dyCols = this.TICKET_INFO_COL.filter(item => item.dataIndex !== 'operation');
      }else {
        this.dyCols = []
      }
      this.refreshList();
    },
    onSave(record) {
      const checkMap = {
        scheduledStartDate: '计划开始时间',
        scheduledCompletionDate: '计划完成时间'
      }
      const errorList = [];
      for(const field in checkMap) {
        if(Array.isArray(record[field]) && !record[field].length) {
          errorList.push(checkMap[field]);
        }else if(!record[field]) {
          errorList.push(checkMap[field]);
        }
      }
      if(errorList?.length) {
        return this.$message.error(errorList.join(',') + '未填写');
      }
      const {
        id,
        scheduledCompletionDate,
        scheduledStartDate
      } = record;
      const params = {
        id,
        scheduledCompletionDate,
        scheduledStartDate
      }
      this.$set(record, 'loading', true);
      updateMesDiscreteJobsMo(params).then(response => {
        if (response.code === 200) {
          this.$message.success('操作成功')
          this.refreshList(true);
        } else {
          this.$message.error(response.msg)
        }
      }).finally(() => {
        this.$set(record, 'loading', false);
      })
    },
    onEdit(record, editStatus) {
      if(![STATUS_CODE.DISPATCHED.lookupCode].includes(record.moStatus)) {
        return this.$message.warning("只有派工状态才能操作")
      }
      if(editStatus) {
        record.tempRow = deepClone(record);
      }else {
        const tempRow = record.tempRow;
        for (const item in record) {
          record[item] = tempRow[item];
        }
        delete record.tempRow;
      }
      this.$set(record, 'editIs', editStatus);
    },
    onSearch(params) {
      if(!params.desOrganizationCode) {
        return this.$message.error('加工组织为空');
      }
      const newParams = { ...params };
      this.$refs.baseTable.searchParams = newParams;
      this.$refs.baseTable.getData(this.currentPageIs)
      this.currentPageIs = false
    },
    refreshList(currentPageIs) {
      this.$nextTick(() => {
        this.currentPageIs = !!currentPageIs
        this.$refs.searchFormRef.handleSearch()
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = this.$refs.baseTable.searchParams;
      this.$refs.download.openModal(params)
    },
    // 合并领料申请
    handleMerge() {
      this.showModal.mergePickModal = true
      this.$nextTick(() => {
        this.$refs.mergePickModalRef.show(this.selectedRows)
      })
    },
    // 呼起AI助手
    callAI() {
      const content =
        "查询MO票的领退料数据，查询要求如下\n" +
        "查询物料编码（多个空格隔开）：300025301 300015469\n" +
        "查询日期范围：最近一周\n" +
        "展示字段（多个空格隔开）：物料编码 MO票号 工作中心 父工单号 计划单号 领料数量 退料数量\n" +
        "展示方式：表格\n" +
        "其他要求：表格可下载"

      this.$EventBus.$emit('AI_CHAT', { confirm: false, content: content });
    },
    // 关闭合并领料申请弹窗
    closeMergePickModal() {
      this.showModal.mergePickModal = false
    },
    onToggleAdvanced() {
      setTimeout(() => {
        this.$refs.baseTable.initScrollY();
      }, 100)
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show();
      getMesDiscreteJobsCcLogApi({ id: row.id, type: 8 }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.link-btn {
  padding: 0 4px;
}
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
/deep/.ant-input-number {
  width: 100%;
}
.select-width-130 {
  /deep/.ant-select {
    width: 120px;
  }
}
.error-border {
  border-color: #ff0000;
  /deep/.ant-select-selection {
    border-color: #ff0000;
  }
}
.error-text {
  font-size: 11px;
  color: #ff0000;
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
</style>
